/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllRatingReviews } from '../../services/operations/courseApi';
import RatingCard from './RatingCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper/modules';

const ReviewSlider = () => {
  const dispatch = useDispatch();
  const [ratings, setRatings] = useState([]);

  useEffect(() => {
    dispatch(getAllRatingReviews(setRatings));
  }, []);

  return (
    <div className='w-full mb-10'>
      {ratings.length > 0 && (
        <div>
        <Swiper
                    slidesPerView={4}
                    spaceBetween={20}
                    freeMode={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                    breakpoints={
                        {
                            1270: {
                                slidesPerView: 4
                            },
                            1024: {
                                slidesPerView: 3
                            },
                            600: {
                                slidesPerView: 2
                            },
                            0: {
                                slidesPerView: 1
                            }
                        }
                    }
                >
            {ratings.map((rating) => (
              <SwiperSlide key={rating?._id}>
                <div>
                  <RatingCard rating={rating} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default ReviewSlider;